<template>
    <app-content class="h-panel">
        <div class="h-panel-bar">
            <span class="h-panel-title">资产汇总</span>
        </div>
        <div class="margin-top margin-left filter-bar">
            <span class="label">期间：</span>
            <DatePicker v-model="p1" type="month" format="yyyy-MM"></DatePicker>
            <span class="label">至</span>
            <DatePicker v-model="p2" type="month" format="yyyy-MM"></DatePicker>
            <Button color="primary" size="s" @click="loadList">查询</Button>
            <Button size="s" @click="exportCsv">导出</Button>
            <Button size="s" @click="printPage">打印</Button>
        </div>
        <div class="h-panel-body">
            <Tabs :datas="tabDatas" v-model="groupBy" @change="loadList" class-name="h-tabs-card"></Tabs>
            <table class="grid">
                <thead>
                <tr>
                    <th rowspan="2" style="width:160px">名称</th>
                    <th colspan="4">资产原值</th>
                    <th colspan="4">累计折旧</th>
                    <th colspan="4">减值准备</th>
                    <th colspan="4">资产净值</th>
                    <th rowspan="2" style="width:110px">预计净残值</th>
                </tr>
                <tr>
                    <template v-for="g in 4">
                        <th :key="g + '-1'" style="width:100px">期初数</th>
                        <th :key="g + '-2'" style="width:100px">本期增加</th>
                        <th :key="g + '-3'" style="width:100px">本期减少</th>
                        <th :key="g + '-4'" style="width:100px">期末数</th>
                    </template>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, i) in datas" :key="i">
                    <td>{{item.name}}</td>
                    <td align="right">{{item.beginOriginal|numFormat}}</td>
                    <td align="right">{{item.addOriginal|numFormat}}</td>
                    <td align="right">{{item.reduceOriginal|numFormat}}</td>
                    <td align="right">{{item.endOriginal|numFormat}}</td>
                    <td align="right">{{item.beginDepreciation|numFormat}}</td>
                    <td align="right">{{item.addDepreciation|numFormat}}</td>
                    <td align="right">{{item.reduceDepreciation|numFormat}}</td>
                    <td align="right">{{item.endDepreciation|numFormat}}</td>
                    <td align="right">{{item.beginImpairment|numFormat}}</td>
                    <td align="right">{{item.addImpairment|numFormat}}</td>
                    <td align="right">{{item.reduceImpairment|numFormat}}</td>
                    <td align="right">{{item.endImpairment|numFormat}}</td>
                    <td align="right">{{item.beginNet|numFormat}}</td>
                    <td align="right">{{item.addNet|numFormat}}</td>
                    <td align="right">{{item.reduceNet|numFormat}}</td>
                    <td align="right">{{item.endNet|numFormat}}</td>
                    <td align="right">{{item.residualValue|numFormat}}</td>
                </tr>
                <tr v-if="!datas.length">
                    <td colspan="18" class="text-center padding">暂无数据</td>
                </tr>
                <tr class="total" v-else>
                    <td align="center">合计</td>
                    <template v-for="(k, i) in TOTAL_KEYS">
                        <td align="right" :key="i">{{total(k)|numFormat}}</td>
                    </template>
                    <td align="right">{{total('residualValue')|numFormat}}</td>
                </tr>
                </tbody>
            </table>
        </div>
    </app-content>
</template>

<script>
const TOTAL_KEYS = [
    'beginOriginal', 'addOriginal', 'reduceOriginal', 'endOriginal',
    'beginDepreciation', 'addDepreciation', 'reduceDepreciation', 'endDepreciation',
    'beginImpairment', 'addImpairment', 'reduceImpairment', 'endImpairment',
    'beginNet', 'addNet', 'reduceNet', 'endNet'
];

export default {
    name: 'AssetsSummary',
    data() {
        const now = new Date();
        return {
            datas: [],
            p1: now,
            p2: now,
            groupBy: 'type',
            tabDatas: { type: '按资产类别汇总', dept: '按使用部门汇总' },
            TOTAL_KEYS
        };
    },
    methods: {
        fmtPeriod(d) {
            if (!d) return '';
            if (typeof d === 'string') return d;
            return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
        },
        loadList() {
            this.$api.assets.assets.summary({
                p1: this.fmtPeriod(this.p1),
                p2: this.fmtPeriod(this.p2),
                groupBy: this.groupBy
            }).then(({ data }) => {
                this.datas = data || [];
            });
        },
        total(field) {
            return this.datas.reduce((s, d) => s + Number(d[field] || 0), 0);
        },
        exportCsv() {
            const head = ['名称',
                '资产原值-期初数', '资产原值-本期增加', '资产原值-本期减少', '资产原值-期末数',
                '累计折旧-期初数', '累计折旧-本期增加', '累计折旧-本期减少', '累计折旧-期末数',
                '减值准备-期初数', '减值准备-本期增加', '减值准备-本期减少', '减值准备-期末数',
                '资产净值-期初数', '资产净值-本期增加', '资产净值-本期减少', '资产净值-期末数',
                '预计净残值'];
            const keys = ['name'].concat(TOTAL_KEYS, ['residualValue']);
            const rows = this.datas.map(d => keys.map(k => d[k]));
            rows.push(['合计'].concat(TOTAL_KEYS.map(k => this.total(k)), [this.total('residualValue')]));
            const csv = [head].concat(rows).map(r => r.map(c => `"${c == null ? '' : c}"`).join(',')).join('\r\n');
            this.download(`资产汇总_${this.fmtPeriod(this.p1)}_${this.fmtPeriod(this.p2)}.csv`, '\ufeff' + csv);
        },
        download(name, content) {
            const blob = new Blob([content], { type: 'text/csv;charset=utf-8' });
            const a = document.createElement('a');
            a.href = URL.createObjectURL(blob);
            a.download = name;
            a.click();
            URL.revokeObjectURL(a.href);
        },
        printPage() { window.print(); }
    },
    mounted() {
        this.loadList();
    }
};
</script>

<style scoped lang="less">
    .filter-bar {
        display: flex;
        align-items: center;
        gap: 8px;
        flex-wrap: wrap;

        .label { margin-left: 6px; }
    }

    .grid {
        width: 100%;
        border-collapse: collapse;
        margin-top: 10px;

        th, td {
            padding: 0 8px;
            border: 1px solid #e2e2e2;
            font-size: 12px;
            height: 32px;
            white-space: nowrap;
        }

        th {
            background-color: #f5f5f5;
            text-align: center;
            font-weight: bold;
            height: 35px;
        }

        tbody tr:nth-child(even) { background-color: #fafafa; }
        tbody tr:hover { background-color: #f0f6ff; }

        .total td { background-color: #f5f5f5; font-weight: bold; }
    }
</style>
